import _ from "lodash";

import { IGenericModelFields } from "../IGenericFields";

export enum WorkspacePermissionObjectType {
    RESOURCE_FOLDER = "resourceFolder",
    WORKSPACE_RESOURCE = "workspaceResource"
}

export enum WorkspacePermissionSubjectType {
    USER = "user",
    USER_GROUP = "userGroup"
}

export interface IWorkspacePermissionAccess {
    read: {
        object: boolean;
        permissions: boolean;
    };
    write: {
        object: boolean;
        permissions: boolean;
    };
    owner: boolean;
}

export interface IWorkspacePermission extends IWorkspacePermissionAccess, IGenericModelFields {
    readonly workspaceId: string;
    readonly objectId: string;
    readonly objectType: WorkspacePermissionObjectType;
    readonly subjectId: string;
    readonly subjectType: WorkspacePermissionSubjectType;
}

const DEFAULT_RESTRICTED_PERMISSIONS_ACCESS: IWorkspacePermissionAccess = {
    read: {
        object: false,
        permissions: false
    },
    write: {
        object: false,
        permissions: false
    },
    owner: false
};

export function GET_DEFAULT_RESTRICTED_PERMISSIONS_ACCESS() {
    return _.cloneDeep(DEFAULT_RESTRICTED_PERMISSIONS_ACCESS);
}
